import { getJson, postJson } from './client'
import type { ThreatsPage } from '../types/threats'
import type { JobView } from '../types/voice'

// Threats: every rival Scout has seen at one of our accounts, and the watch that finds them.
const threats = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/threats`

export const threatsApi = {
  list: (spoke: string) => getJson<ThreatsPage>(threats(spoke)),
  /** Starts the threat-watch job: eighteen months of meetings and every thread, re-read against the register. */
  watch: (spoke: string) => postJson<JobView>(`${threats(spoke)}/watch`, {}),
}
